import {configureStore} from '@reduxjs/toolkit';
import {filterLoaderSlice, loaderSlice} from './LoaderSlice.jsx';
import {articleAjaxCallSlice, contentAjaxCallSlice, filterAjaxCallSlice} from './AjaxCallSlice.jsx';
import {filterSlice} from './FilterSlice.jsx';

const createStore = () => {
    return configureStore({
        reducer: {
            loader: loaderSlice.reducer,
            filterLoader: filterLoaderSlice.reducer,
            filter: filterSlice.reducer,
            filterAjaxCall: filterAjaxCallSlice.reducer,
            contentAjaxCall: contentAjaxCallSlice.reducer,
            articleAjaxCall: articleAjaxCallSlice.reducer,
        },
    });
};

export default createStore;
